export const enum FathomEvent {
  BUY = "buy",
  QSR_DONWNLOAD = "quick_start_rules_download",
  PARTNER_REFERRAL = "partner_referral",
}
